import { Checkbox } from 'component-library';

import { FormControl, FormItem, FormLabel } from '@/components/Form';

import { TextContainer } from '../../a/Text/Text';
import { useControlsContext } from './Form';

type CheckboxWidgetProps = {
  i18nPath?: string;
  text?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formName: any;
};
export const CheckboxWidget = ({ value, formName, i18nPath, text, ...delegated }: CheckboxWidgetProps) => {
  const { setValue, watch } = useControlsContext();

  const selectedFormValue = watch(formName);
  const isArrayFormData = Array.isArray(selectedFormValue);

  const handleCheckedChange = () => {
    let newValue = value;

    if (isArrayFormData) {
      newValue = selectedFormValue.includes(value)
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          selectedFormValue.filter((v: any) => v !== value)
        : [...selectedFormValue, value];
    }

    setValue(formName, newValue);
  };

  const isChecked = isArrayFormData ? selectedFormValue.includes(value) : selectedFormValue === value;

  return (
    <FormItem>
      <FormControl>
        <Checkbox checked={isChecked} onCheckedChange={handleCheckedChange} value={value} id={value} {...delegated}>
          <FormLabel htmlFor={value}>
            {(text || i18nPath) && <TextContainer text={text} i18nPath={i18nPath} />}
          </FormLabel>
        </Checkbox>
      </FormControl>
    </FormItem>
  );
};
